// This file was auto generated by resource-sync tools.

import en_cti_fe from './en/cti_fe.json';
import zh_cti_fe from './zh/cti_fe.json';
import zhHK_cti_fe from './zh-HK/cti_fe.json';

const resources = {
    en: {
        cti_fe: en_cti_fe
    },
    zh: {
        cti_fe: zh_cti_fe
    },
    'zh-HK': {
        cti_fe: zhHK_cti_fe
    }
};

export default resources;
